import React, { useEffect, useState } from "react";
import s from  "./preview.module.scss";

const Preview = (props) => {

    const [items, setItems] = useState(props.items ? props.items : []);

    useEffect(() => {
        setItems(props.items ? props.items : []);
    }, [props]);

    const componentNames = items.map((k, i) => <div key={i}><span>{i+1}</span><span>{k}</span></div>);

    return (
        <div className={s.Preview}>
            { componentNames }
        </div>
    )
}

export default Preview;